module.exports = __webpack_public_path__ + "media/img/description/description-trainings-after-acc60d959ba86cb90d4bc28dabf9dcf6.svg";